<template>

  <div class="gewerbe-vorversicherung bg-dimmed round-corners pt-4">
    <v-icon v-if="remove"
            class="delete-icon"
            @click="$emit('remove')">close
    </v-icon>

    <v-row no-gutters>

      <v-col cols="12"
             sm="3"
             class="px-4">
        <div class="dmb-form-text dmb-blue">
          Vorversicherung {{ index + 1 }}
        </div>
      </v-col>

      <v-col cols="12"
             sm="9"
             class="pl-4">

          <v-row no-gutters>

            <v-col cols="12"
                   md="6"
                   class="pr-4">
              <v-text-field v-model="vorversicherer"
                            v-validate="'required'"
                            v-dmb-trim
                            :error-messages="errors.collect('vorversicherer')"
                            data-vv-as="Vorversicherer"
                            class="required"
                            name="vorversicherer"
                            label="Vorversicherer" />
            </v-col>

            <v-col cols="12"
                   md="6"
                   class="pr-4">
              <v-text-field v-model="vscheinnr"
                            v-validate="'required'"
                            v-dmb-trim
                            :error-messages="errors.collect('vscheinnr')"
                            data-vv-as="Versicherungsschein-Nr."
                            class="required"
                            name="vscheinnr"
                            label="Versicherungsschein-Nr." />
            </v-col>

            <v-col cols="4"
                   md="3">
              <div class="dmb-form-text pt-1">gekündigt durch*</div>
            </v-col>

            <v-col cols="8"
                   md="9"
                   class="pl-4">
              <v-radio-group v-model="von"
                             v-validate="'required'"
                             :error-messages="errors.collect('von')"
                             data-vv-as="gekündigt durch"
                             data-vv-name="von"
                             name="von"
                             hide-details
                             row>

                    <v-radio label="Versicherungsnehmer"
                             value="VN"
                             color="primary" />
                    <v-radio label="Versicherung"
                             value="VR"
                             color="primary" />

              </v-radio-group>

            </v-col>

            <v-col cols="12"
                   md="6"
                   class="pr-4">
              <date-field v-model="zum"
                          v-validate="'required|date_format:DD.MM.YYYY'"
                          :error-messages="errors.collect('zum')"
                          data-vv-as="Kündigungsdatum"
                          class="required"
                          hint="tt.mm.jjjj"
                          name="zum"
                          label="gekündigt zum" />
            </v-col>

          </v-row>
      </v-col>

    </v-row>

  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import DateField from "@/components/DateField";

export default {
  name: 'GewerbeVorversicherung',
  components: { DateField },
  mixins: [ValidationMixin, twowayBinding],
  props: {
    index: {
      type: Number,
      required: true
    },
    remove: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapTwoWay(["vscheinnr", "zum", "von", "vorversicherer"])
  }
};
</script>

<style>
.gewerbe-vorversicherung {
  position: relative;
}

.gewerbe-vorversicherung .delete-icon {
  position: absolute;
  top: 8px;
  right: 8px;
  color: rgba(0, 0, 0, .87);
}

.gewerbe-vorversicherung .dmb-blue {
  color: #002C76;
}

.gewerbe-vorversicherungen .gewerbe-vorversicherung .v-input--radio-group__input .v-radio:not(:last-child) {
  margin-right: 16px!important;
}
</style>

